import type { ViewContentData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class ViewContentTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: ViewContentData): void {
    if (!this.factory.isManualEnabled('viewContent')) return;
    this.factory.dispatchManual('VIEW_CONTENT', data);
  }
}
